import React from 'react';
import Deal from './deal';
import Customize from './customize';
import './index.scss';

export default function Index({
  productLightCustomizationList,
  lightCustomModel,
  customModel,
  productId,
  companyId,
  productEncryptId,
  price,
}) {
  return (
    <Deal
      productLightCustomizationList={productLightCustomizationList}
      price={price}
    >
      {(lightCustomModel || customModel) && (
        <Customize
          lightCustomModel={lightCustomModel}
          customModel={customModel}
          productId={productId}
          companyId={companyId}
          productEncryptId={productEncryptId}
        />
      )}
    </Deal>
  );
}
